<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>

    <!-- 사업 또는 사업장의 안전보건 목표와 경영방침 설정 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5>
            <i class="dot"></i> 사업 또는 사업장의 안전보건 목표와 경영방침 설정
          </h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-4 flex items-center mt-4">
          <div class="label-text mr-4">대상기간</div>
          <p v-if="isPrint" class="print-input">
            {{ form.inputB_1 }} ~ {{ form.inputB_2 }}
          </p>
          <div v-else class="flex-1 flex items-center">
            <date-selector
              class="w-full flex-1"
              v-model="form.inputB_1"
              :readonly="board.readonly"
            />
            <p class="px-2">~</p>
            <date-selector
              class="w-full flex-1"
              v-model="form.inputB_2"
              :readonly="board.readonly"
            />
          </div>
        </div>
        <div class="col-span-12 flex items-start mt-4">
          <div class="label-text mr-4 mt-2">정책비전</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_3 }} </span>
          <ml-textarea
            v-else
            class="flex-1 w-full"
            rows="5"
            v-model="form.inputB_3"
            :readonly="board.readonly"
          />
        </div>
        <div class="col-span-12 flex items-start">
          <div class="label-text mr-4 mt-2">실천목표</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputB_4 }} </span>
          <ml-textarea
            v-else
            class="flex-1 w-full"
            rows="5"
            v-model="form.inputB_4"
            :readonly="board.readonly"
          />
        </div>
      </div>
    </div>

    <!-- 이미지 업로드 -->
    <photo-upload-grid-module
      :row-count="1"
      :grid-count="1"
      v-model="form.photoList"
      section-title="이미지 업로드"
      :is-print="isPrint"
      :readonly="board.readonly"
      placeholder="경영방침"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FileUploadModule,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},

        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        inputB_4: '',

        photoList: [],
        fileList: [],
      },
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>

<!--<template>-->
<!--  <div>-->
<!--    &lt;!&ndash;기본정보&ndash;&gt;-->
<!--    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint"/>-->

<!--    &lt;!&ndash;    요청자정보&ndash;&gt;-->
<!--    <div class="mb-6">-->
<!--      <p class="title mb-5"><i class="dot"></i>요청자 정보(필요시 작성)</p>-->
<!--      <div class="grid grid-cols-12 gap-x-6 gap-y-4">-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">소속명</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputB_1 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputB_1"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">부서명</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputB_2 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputB_2"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">요청자</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputB_3"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">직책</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputB_4 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputB_4"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">연락처</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputB_5 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputB_5"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">이메일</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputB_6 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputB_6"-->
<!--          />-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

<!--    &lt;!&ndash;    파트너사 정보&ndash;&gt;-->
<!--    <div class="mb-6">-->
<!--      <p class="title mb-5"><i class="dot"></i>파트너사 정보</p>-->
<!--      <div class="grid grid-cols-12 gap-x-6 gap-y-4">-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">사업명</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputC_1 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputC_1"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">업체명</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputC_2 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputC_2"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">업체 담당자</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputC_3 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputC_3"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">연락처</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputC_4 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputC_4"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="col-span-4 flex items-center">-->
<!--          <div class="label-text mr-4">이메일</div>-->
<!--          <span v-if="isPrint" class="print-input"> {{ form.inputC_5 }} </span>-->
<!--          <ml-input-->
<!--            v-else-->
<!--            :readonly="board.readonly"-->
<!--            class="w-full flex-1"-->

<!--            v-model="form.inputC_5"-->
<!--          />-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="col-span-12 flex items-start mt-4">-->
<!--        <div class="label-text mr-4">내용</div>-->
<!--        <span v-if="isPrint" class="print-input"> {{ form.inputC_6 }} </span>-->
<!--        <ml-textarea-->
<!--          v-else-->
<!--          class="flex-1 w-full"-->
<!--          rows="5"-->
<!--          v-model="form.inputC_6"-->
<!--          :readonly="board.readonly"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->

<!--    &lt;!&ndash; 사업 또는 사업장의 안전보건 목표와 경영방침 설정 &ndash;&gt;-->
<!--&lt;!&ndash;    <div class="mt-5">&ndash;&gt;-->
<!--&lt;!&ndash;      <vs-row class="my-4">&ndash;&gt;-->
<!--&lt;!&ndash;        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">&ndash;&gt;-->
<!--&lt;!&ndash;          <h5>&ndash;&gt;-->
<!--&lt;!&ndash;            <i class="dot"></i> 사업 또는 사업장의 안전보건 목표와 경영방침 설정&ndash;&gt;-->
<!--&lt;!&ndash;          </h5>&ndash;&gt;-->
<!--&lt;!&ndash;        </vs-col>&ndash;&gt;-->
<!--&lt;!&ndash;      </vs-row>&ndash;&gt;-->
<!--&lt;!&ndash;      <div class="col-span-12 flex items-start mt-4">&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="label-text">대상기간</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <p v-if="isPrint" class="print-input" class="w-full flex-1">&ndash;&gt;-->
<!--&lt;!&ndash;          {{ form.inputB_1 }} ~ {{ form.inputB_2 }}&ndash;&gt;-->
<!--&lt;!&ndash;        </p>&ndash;&gt;-->
<!--&lt;!&ndash;        <div v-else class="flex items-center">&ndash;&gt;-->
<!--&lt;!&ndash;          <date-selector&ndash;&gt;-->
<!--&lt;!&ndash;            class="w-full flex-1"&ndash;&gt;-->
<!--&lt;!&ndash;            v-model="form.inputB_1"&ndash;&gt;-->
<!--&lt;!&ndash;            :readonly="board.readonly"&ndash;&gt;-->
<!--&lt;!&ndash;          />&ndash;&gt;-->
<!--&lt;!&ndash;          <p class="px-2">~</p>&ndash;&gt;-->
<!--&lt;!&ndash;          <date-selector&ndash;&gt;-->
<!--&lt;!&ndash;            class="w-full flex-1"&ndash;&gt;-->
<!--&lt;!&ndash;            v-model="form.inputB_2"&ndash;&gt;-->
<!--&lt;!&ndash;            :readonly="board.readonly"&ndash;&gt;-->
<!--&lt;!&ndash;          />&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--&lt;!&ndash;      <div class="col-span-12 flex items-start mt-4">&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="label-text mt-2">정책비전</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <span v-if="isPrint" class="print-input"> {{ form.inputB_3 }} </span>&ndash;&gt;-->
<!--&lt;!&ndash;        <ml-textarea&ndash;&gt;-->
<!--&lt;!&ndash;          v-else&ndash;&gt;-->
<!--&lt;!&ndash;          class="flex-1 w-full"&ndash;&gt;-->
<!--&lt;!&ndash;          rows="5"&ndash;&gt;-->
<!--&lt;!&ndash;          v-model="form.inputB_3"&ndash;&gt;-->
<!--&lt;!&ndash;          :readonly="board.readonly"&ndash;&gt;-->
<!--&lt;!&ndash;        />&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--&lt;!&ndash;      <div class="col-span-12 flex items-start">&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="label-text mt-2">실천목표</div>&ndash;&gt;-->
<!--&lt;!&ndash;        <span v-if="isPrint" class="print-input"> {{ form.inputB_4 }} </span>&ndash;&gt;-->
<!--&lt;!&ndash;        <ml-textarea&ndash;&gt;-->
<!--&lt;!&ndash;          v-else&ndash;&gt;-->
<!--&lt;!&ndash;          class="flex-1 w-full"&ndash;&gt;-->
<!--&lt;!&ndash;          rows="5"&ndash;&gt;-->
<!--&lt;!&ndash;          v-model="form.inputB_4"&ndash;&gt;-->
<!--&lt;!&ndash;          :readonly="board.readonly"&ndash;&gt;-->
<!--&lt;!&ndash;        />&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->

<!--&lt;!&ndash;    &lt;!&ndash; 이미지 업로드 &ndash;&gt;&ndash;&gt;-->
<!--&lt;!&ndash;    <div class="mt-5">&ndash;&gt;-->
<!--&lt;!&ndash;      <vs-row class="my-4">&ndash;&gt;-->
<!--&lt;!&ndash;        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">&ndash;&gt;-->
<!--&lt;!&ndash;          <h5><i class="dot"></i> 이미지 업로드</h5>&ndash;&gt;-->
<!--&lt;!&ndash;        </vs-col>&ndash;&gt;-->
<!--&lt;!&ndash;      </vs-row>&ndash;&gt;-->
<!--&lt;!&ndash;      <div class="h-upload">&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="upload-content__file p-0">&ndash;&gt;-->
<!--&lt;!&ndash;          <FileUploader&ndash;&gt;-->
<!--&lt;!&ndash;            v-if="!isPrint"&ndash;&gt;-->
<!--&lt;!&ndash;            type="only-image"&ndash;&gt;-->
<!--&lt;!&ndash;            v-model="form.inputC_1"&ndash;&gt;-->
<!--&lt;!&ndash;          />&ndash;&gt;-->
<!--&lt;!&ndash;          <img class="w-full h-full" v-else :src="form.inputC_1.thumb" alt="" />&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;        <div class="col-span-12 flex items-start mt-4">&ndash;&gt;-->
<!--&lt;!&ndash;          <span v-if="isPrint" class="print-input"> {{ form.inputC_2 }} </span>&ndash;&gt;-->
<!--&lt;!&ndash;          <ml-input&ndash;&gt;-->
<!--&lt;!&ndash;            v-else&ndash;&gt;-->
<!--&lt;!&ndash;            class="w-full flex-1"&ndash;&gt;-->
<!--&lt;!&ndash;            v-model="form.inputC_2"&ndash;&gt;-->
<!--&lt;!&ndash;            :readonly="board.readonly"&ndash;&gt;-->
<!--&lt;!&ndash;            placeholder="경영방침"&ndash;&gt;-->
<!--&lt;!&ndash;          />&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->

<!--    &lt;!&ndash;    파일첨부&ndash;&gt;-->
<!--    <file-upload-module-->
<!--      id="fileList"-->
<!--      class="w-full mt-4"-->
<!--      v-model="form.fileList"-->
<!--      :readonly="board.readonly"-->
<!--    ></file-upload-module>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--import FieldSelectModule from '@/views/modules/FieldSelectModule'-->
<!--import FileUploader from '@/components/FileUploader'-->
<!--import FileUploadModule from '@/views/modules/FileUploadModule'-->
<!--import DateSelector from '@/components/selector/DateSelector'-->

<!--export default {-->
<!--  components: {-->
<!--    FieldSelectModule,-->
<!--    FileUploader,-->
<!--    FileUploadModule,-->
<!--    DateSelector,-->
<!--  },-->
<!--  props: {-->
<!--    isPrint: Boolean,-->
<!--    board: Object,-->
<!--    value: Object,-->
<!--  },-->
<!--  watch: {-->
<!--    value: {-->
<!--      important: true,-->
<!--      deep: true,-->
<!--      handler (value) {-->
<!--        const keys = Object.keys(this.form)-->
<!--        for (const key of keys) {-->
<!--          if (value[key]) {-->
<!--            this.form[key] = value[key]-->
<!--          }-->
<!--        }-->
<!--      }-->
<!--    },-->
<!--    form: {-->
<!--      immediate: true,-->
<!--      deep: true,-->
<!--      handler (value) {-->
<!--        this.$emit('input', value)-->
<!--      },-->
<!--    },-->
<!--  },-->
<!--  data () {-->
<!--    return {-->
<!--      form: {-->
<!--        stdInfo: {},-->

<!--        inputB_1: '',-->
<!--        inputB_2: '',-->
<!--        inputB_3: '',-->
<!--        inputB_4: '',-->
<!--        inputB_5: '',-->
<!--        inputB_6: '',-->

<!--        inputC_1: '',-->
<!--        inputC_2: '',-->
<!--        inputC_3: '',-->
<!--        inputC_4: '',-->
<!--        inputC_5: '',-->
<!--        inputC_6: '',-->

<!--        // inputB_1: "",-->
<!--        // inputB_2: "",-->
<!--        // inputB_3: "",-->
<!--        // inputB_4: "",-->
<!--        //-->
<!--        // inputC_1: {},-->
<!--        // inputC_2: "",-->

<!--        fileList: [],-->
<!--      },-->
<!--    }-->
<!--  },-->
<!--}-->
<!--</script>-->

<!--<style scoped lang="scss">-->
<!--$border: 1px solid #cdcdcd;-->
<!--.label-text {-->
<!--  width: 110px;-->
<!--  font-weight: 500;-->
<!--  font-size: 14px;-->
<!--  padding-right: 16px;-->
<!--}-->

<!--.mt-component-form {-->
<!--  margin-top: 15px;-->
<!--}-->

<!--/* uploaded File */-->
<!--.h-upload {-->
<!--  height: 470px;-->
<!--}-->

<!--.upload-content {-->
<!--  border: $border;-->

<!--  &:last-child {-->
<!--    border-left: none;-->
<!--  }-->

<!--  &__title {-->
<!--    height: 54px;-->
<!--    line-height: 54px;-->
<!--    text-align: center;-->
<!--    background: #fafafa;-->
<!--    border-bottom: $border;-->
<!--  }-->

<!--  &__input {-->
<!--    height: 54px;-->
<!--    background: #f9f9f9;-->
<!--    border-top: $border;-->
<!--    padding: 5px 15px;-->
<!--    display: flex;-->
<!--    align-items: center;-->
<!--    justify-content: center;-->
<!--  }-->

<!--  &__file {-->
<!--    height: calc(100% - 54px);-->
<!--    width: 100%;-->
<!--    padding: 14px;-->
<!--  }-->
<!--}-->
<!--</style>-->
